<template>
    <div>
        <b-row v-if="token == null">
            <b-col>
                <b-row align-h="center" align="center">
                    <b-col cols="12" sm="12" md="11" lg="11" class="fadeInDown ">
                        <p></p>

                        <b-row>
                            <b-col>
                                <b-form-select v-model="estacionSelected" :options="estacion"></b-form-select>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <p></p>
                                <h1 class="mt-4">{{ passOculto }}</h1>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="4">
                                <b-button block @click="boton(1)" variant="outline-primary" class="mb-4">1</b-button>
                            </b-col>
                            <b-col cols="4">
                                <b-button block @click="boton(2)" variant="outline-primary" class="mb-4">2</b-button>
                            </b-col>
                            <b-col>
                                <b-button block @click="boton(3)" variant="outline-primary" class="mb-4">3</b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-button block @click="boton(4)" variant="outline-primary" class="mb-4">4</b-button>
                            </b-col>
                            <b-col>
                                <b-button block @click="boton(5)" variant="outline-primary" class="mb-4">5</b-button>
                            </b-col>
                            <b-col>
                                <b-button block @click="boton(6)" variant="outline-primary" class="mb-4">6</b-button>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-button block @click="boton(7)" variant="outline-primary" class="mb-4">7</b-button>
                            </b-col>
                            <b-col>
                                <b-button block @click="boton(8)" variant="outline-primary" class="mb-4">8</b-button>
                            </b-col>
                            <b-col>
                                <b-button block @click="boton(9)" variant="outline-primary" class="mb-4">9</b-button>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-icon style="cursor: pointer;" @click="eliminarPass()" variant="danger"
                                    icon="arrow-left-circle-fill" font-scale="3" class="mb-1 mt-1"></b-icon>
                            </b-col>
                            <b-col>
                                <b-button block @click="boton(0)" variant="outline-primary" class="mb-4">0</b-button>
                            </b-col>
                            <b-col>
                                <b-icon style="cursor: pointer;" @click="enviarPass()" variant="success"
                                    icon="check-circle-fill" font-scale="3" class="mb-1 mt-1"></b-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>

        </b-row>
        <b-row>
            <b-col v-if="token != null">
                <b-tabs>

                    <!-- VALES -->
                    <b-tab title="Generar Vale" active class="wrapper fadeInDown">
                        <Vale></Vale>
                    </b-tab>

                    <!-- LOTES -->
                    <b-tab title="Lotes" class="wrapper fadeInDown">
                        <Lotes></Lotes>
                    </b-tab>

                    <!-- REPORTES -->
                    <b-tab title="Reportes" class="wrapper fadeInDown">
                        <Reportes></Reportes>
                    </b-tab>

                    <!-- CATALOGOS -->
                    <b-tab title="Catalogos" class="wrapper fadeInDown">
                        <Catalogos></Catalogos>
                    </b-tab>

                    <!-- FACTURACION -->
                    <b-tab title="Facturación" class="wrapper fadeInDown">
                        <Facturacion></Facturacion>
                    </b-tab>

                    <!-- VALIDACION -->
                    <b-tab title="Validación" class="wrapper fadeInDown">
                        <Validacion></Validacion>
                    </b-tab>

                    <!-- CONFIGURACION -->
                    <b-tab title="Configuracion" class="wrapper fadeInDown">
                        <Configuracion></Configuracion>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>




<script>
import axios from 'axios'
import Validacion from './Validacion.vue';
import Lotes from './Lotes.vue';
import Facturacion from './Facturacion.vue';
import Catalogos from './Catalogos.vue';
import Reportes from './Reportes.vue';
import Vale from './Vale.vue';
import Configuracion from './Configuracion.vue';




export default {


    computed: {
        token: {
            get: function () {
                return this.$store.state.user.token;
            },
            set: function (newIsWorking) {
                this.$store.commit("updateToken", newIsWorking);
            }
        }

    },

    data() {
        return {
            //variables Generacion Vale
            cliente: "",
            //url: "http://192.168.0.100:8080/",
            //url: "https://optimal-central-pug.ngrok-free.app/",
            //url: "https://tphavawsqa.a.pinggy.link/",
            //url: "http://192.168.0.101:8080/",
            url: "https://recaudacion.gobrecservices.com/",


            banderaLogin: 1,
            pass: '',
            password: 123,
            passOculto: '',
            valorBoton: '',

            estacionSelected: 'ESTACION01',
            estacion: [
                { value: 'ESTACION01', text: 'ESTACION 01' },
                { value: 'ESTACION02', text: 'ESTACION 02' },
                { value: 'ESTACION03', text: 'ESTACION 03' },
                { value: 'ESTACION04', text: 'ESTACION 04' },
                { value: 'ESTACION05', text: 'ESTACION 05' }
            ],

        }
    },
    components: { Vale, Validacion, Lotes, Facturacion, Catalogos, Reportes, Configuracion },

    created: function () {

        const queryString = window.location.href;

        const url = new URL(queryString);

        const cliente = url.pathname.split('/')[1];

        this.cliente = cliente

    },


    methods: {

        enviarPass() {


            this.passBase64 = btoa(this.pass);

            this.banderaLogin = this.pass;

            axios({
                method: 'post',
                url: this.url + 'authenticatesuministro',
                params: { "codeClient": this.cliente },
                data: {
                    "username": this.estacionSelected + "-" + this.cliente + "-suministro",
                    "password": this.passBase64
                }
            })
                .then((res) => {

                    this.token = res.data.token
                    this.registros = []
                    //alert(res.status)
                }).catch(err => {

                    if (err.response.status == 401) {

                        this.pass = '';
                        this.passOculto = '';

                        alert('Usuario o contraseña incorrectos');
                        //alert(err.response.status)

                    }

                    else {

                        alert('Servicio no disponible, intente de nuevo más tarde');

                    }
                    

                });

        },

        eliminarPass() {
            this.pass = '';
            this.passOculto = '';
        },


        boton(valorBoton) {
            this.pass = this.pass + valorBoton;
            this.passOculto = this.passOculto + '*';
        }

    }
}

</script>



<style>
/* BASIC */

html {
    background-color: #ffffff;
}

body {
    font-family: "Poppins", sans-serif;
    height: 100vh;
}

a {
    color: #92badd;
    display: inline-block;
    text-decoration: none;
    font-weight: 400;
}

h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
    margin: 40px 8px 10px 8px;
    color: #cccccc;
}



/* STRUCTURE */

.wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 20px;
}

#formContent {
    -webkit-border-radius: 10px 10px 10px 10px;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    padding: 30px;
    width: 90%;
    max-width: 450px;
    position: relative;
    padding: 0px;
    -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    text-align: center;
}

#formFooter {
    background-color: #f6f6f6;
    border-top: 1px solid #dce8f1;
    padding: 25px;
    text-align: center;
    -webkit-border-radius: 0 0 10px 10px;
    border-radius: 0 0 10px 10px;
}



/* TABS */

h2.inactive {
    color: #cccccc;
}

h2.active {
    color: #0d0d0d;
    border-bottom: 2px solid #ffffff;
}



/* FORM TYPOGRAPHY*/

input[type=button],
input[type=submit],
input[type=reset] {
    background-color: #56baed;
    border: none;
    color: white;
    padding: 15px 80px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    font-size: 13px;
    -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
    margin: 5px 20px 40px 20px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
    background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
    -moz-transform: scale(0.95);
    -webkit-transform: scale(0.95);
    -o-transform: scale(0.95);
    -ms-transform: scale(0.95);
    transform: scale(0.95);
}

input[type=text] {
    background-color: #f6f6f6;
    border: none;
    color: #0d0d0d;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
    width: 85%;
    border: 2px solid #f6f6f6;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
    background-color: #fff;
    border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder {
    color: #cccccc;
}



/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

@keyframes fadeInDown {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -100%, 0);
        transform: translate3d(0, -100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@-moz-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.card-option {
    box-shadow: 0px 5px 35px 5px #cccaca;
    border-radius: 15px;
    border-bottom: solid 4px rgb(68, 63, 173);
    background-color: white;
}

.fadeIn {
    opacity: 0;
    -webkit-animation: fadeIn ease-in 1;
    -moz-animation: fadeIn ease-in 1;
    animation: fadeIn ease-in 1;

    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    animation-fill-mode: forwards;

    -webkit-animation-duration: 1s;
    -moz-animation-duration: 1s;
    animation-duration: 1s;
}

.fadeIn.first {
    -webkit-animation-delay: 0.4s;
    -moz-animation-delay: 0.4s;
    animation-delay: 0.4s;
}

.fadeIn.second {
    -webkit-animation-delay: 0.6s;
    -moz-animation-delay: 0.6s;
    animation-delay: 0.6s;
}

.fadeIn.third {
    -webkit-animation-delay: 0.8s;
    -moz-animation-delay: 0.8s;
    animation-delay: 0.8s;
}

.fadeIn.fourth {
    -webkit-animation-delay: 1s;
    -moz-animation-delay: 1s;
    animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
    display: block;
    left: 0;
    bottom: -10px;
    width: 0;
    height: 2px;
    background-color: #56baed;
    content: "";
    transition: width 0.2s;
}

.underlineHover:hover {
    color: #0d0d0d;
}

.underlineHover:hover:after {
    width: 100%;
}



/* OTHERS */

*:focus {
    outline: none;
}

#icon {
    width: 60%;
}
</style>